var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3434_6002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.81757 15.1814L9.42057 20.7654C9.98857 20.7654 10.2346 20.5214 10.5296 20.2284L13.1926 17.6834L18.7106 21.7244C19.7226 22.2884 20.4356 21.9914 20.7086 20.7934L24.3306 3.82141L24.3316 3.82041C24.6526 2.32441 23.7906 1.73941 22.8046 2.10641L1.51457 10.2574C0.0615685 10.8214 0.0835685 11.6314 1.26757 11.9984L6.71057 13.6914L19.3536 5.78041C19.9486 5.38641 20.4896 5.60441 20.0446 5.99841L9.81757 15.1814Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3434_6002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.399902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b89d1545adc95ad92fc3bd7dc161a6ba.svg";
export { ForwardRef as ReactComponent };